module.exports = __webpack_public_path__ + "img/petstairs41.ed7bc560.jpg";